import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "../lib/api";
import { useAuth } from "./AuthContext";
import { toast } from "sonner";

const CartContext = createContext({});

export function CartProvider({ children }) {
  const { user } = useAuth();
  const [cart, setCart] = useState({ items: [], count: 0, subtotal: 0 });

  const refresh = useCallback(async () => {
    if (!user) { setCart({ items: [], count: 0, subtotal: 0 }); return; }
    try { const r = await api.get("/cart"); setCart(r.data); } catch {}
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const add = async (productId, qty = 1) => {
    if (!user) { toast.info("Sign in to add to cart"); return; }
    const { data } = await api.post("/cart/add", { product_id: productId, qty });
    setCart(data);
    toast.success("Added to cart");
  };
  const update = async (productId, qty) => {
    const { data } = await api.put("/cart/update", { product_id: productId, qty });
    setCart(data);
  };
  const remove = async (productId) => {
    const { data } = await api.delete(`/cart/remove/${productId}`);
    setCart(data);
  };

  return (
    <CartContext.Provider value={{ cart, add, update, remove, refresh }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
